// src/Pages/Cadastro/CadImportPrices.tsx
import { useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import { ThemeContext } from '../../context/theme-context';
import ListaImportPrices from '../../Components/Cadastro/ImportPrices/ListaImportPrices';
import FormImportPrices from '../../Components/Cadastro/ImportPrices/FormImportPrices';

export interface IListImportPrices {
  title: string;
  OnAddNewImport: (e: boolean) => void;
}

export interface IFormImportPrices {
  title: string;
  OnAddNewImport: (e: boolean) => void;
}

export default function CadImportPrices() {
  const { collapsed } = useContext(ThemeContext);
  // ✅ MODIFICADO: Agora inicia como true para abrir direto no formulário
  const [showForm, setShowForm] = useState<boolean>(true);

  const handleNew = (e: boolean) => {
    setShowForm(e);
  };

  return (
    <>
      {!showForm ? (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <ListaImportPrices
            title="Importação de Tabela de Preços"
            OnAddNewImport={(e: boolean) => handleNew(e)}
          />
        </Container>
      ) : (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <FormImportPrices
            title="Importar Tabela de Preços"
            OnAddNewImport={(e: boolean) => handleNew(e)}
          />
        </Container>
      )}
    </>
  );
}